import { useEffect } from 'react';

import { useAuth } from '@/contexts/AuthContext';

export function Logout() {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return null;
}
